var map = {
	"./daizy_agriculture.jpg": "317b",
	"./daizy_beach.jpg": "234b",
	"./daizy_bridge.jpg": "903b",
	"./daizy_city.jpg": "3615",
	"./daizy_construction.jpg": "9b82",
	"./daizy_docks.jpg": "6ec5",
	"./daizy_housing.jpg": "7e1d",
	"./daizy_lulworth.jpg": "58f1",
	"./daizy_market.jpg": "8d571",
	"./daizy_new_forest.jpg": "bdfb",
	"./daizy_peak.jpg": "d637",
	"./daizy_rail.jpg": "8ff2",
	"./daizy_river.jpg": "f5af",
	"./daizy_solar.jpg": "a49b",
	"./daizy_traffic.jpg": "7337",
	"./daizy_warehouse.jpg": "d016",
	"./daizy_water.jpg": "d4a4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "db46";